<template>
  <div>
    <h2>Supported file format for JSON Media File</h2>
    <h4>1. ProjectVIC format</h4>
       <ul>
         <li>Supports photoDNA, SHA1, and MD5. If more than one type present for same media, Arthropod will extract only <b>one</b> in that order.</li>
       </ul>
    <h4>2. Arthropod media search format</h4>
      <ul>
        <li>Supports photoDNA, SHA1, and MD5. If SHA1 and MD5 available for same media, provide one to avoid duplicate search results.</li>
        <li>Single root element <b>arthropod_media_search</b> with a dictionary of one to three identifier lists for supported hashes.</li>
        <li>Dictionary keys: use <b>sha1</b> or <b>hash</b> for sha1, <b>pdna</b> or <b>photodna</b> for photodna, and <b>md5</b> for md5.</li>
        <li>Should contain at least one list. If more than one, order irrelevant.</li>
        <li> Examples </li>
          <ol>
    <code>
    # JSON with all the SHA1, PDNA and MD5
    {
      "arthropod_media_search": {
        "hash": [
          "LPzBiD27OoglBC2bTDpMsmmqAdmZ32t1",
          "len32noresultsnoresultsnoresults"
        ],
        "pdna": [
          "0d6a0af...0814082d"
        ],
        "md5": [
          "LPzBiD27OoglBC2bTDpMsmmqAdmZ32ty",
          "LPzBiD27OoglBC2bTDpMsmmqAdmZ32t1"
        ]
      }
    }

    # JSON with a single MD5
    {
      "arthropod_media_search": {
        "md5": [
          "LPzBiD27OoglBC2bTDpMsmmqAdmZ32ty"
        ]
      }
    }
    </code>


          </ol>
      </ul>

  </div>
</template>

<script>
export default {
  name: 'ResultAreaForJson'
}
</script>
